import { createContext } from "react";

const CampaignsContext = createContext({});

export default CampaignsContext;
